import React, { useContext, useLayoutEffect, useState } from "react";
import { ToastContext } from "../../component/global/ToastContext";

import Skeleton from "react-loading-skeleton";
import {
    disLikeFeedback,
    likeFeedback,
} from "../../controlers/messages/FeedbackController";
import moment from "moment-jalaali";
import IconBox from "../../component/global/IconBox";
import { getTextDigest } from "../../utils/methods";
import StarRatings from "react-star-ratings";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { ReactComponent as CalendarIcon } from "./../../../src/asset/icons/cal.svg";
import { ReactComponent as CommentIcon } from "./../../../src/asset/icons/comments.svg";
import { ReactComponent as Target } from "./../../../src/asset/icons/target.svg";
import defaultImg from "../../asset/image/default_photo.png";
import { useTranslation } from "react-i18next";
import MessageStatusBadge from "./MessageStatusBadge";

export default function FeedbackItemList({
    id,
    score,
    user,
    computed_score,
    item,
    likes_count,
    dislikes_count,
    description,
    datetime,
    onItemClick,
    row,
    file,
    feedback_status,
    user_coin,
    showCoins,
    company,
}) {
    const show = useContext(ToastContext);
    const [newMessagesAlert, setNewMessagesAlert] = useState();
    const { t } = useTranslation();

    function round(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }

    const handleLikeClick = (event) => {
        event.stopPropagation();
        likeFeedback(id).then(() => {
            show(t("Src.Pages.Messages.FeedbackItem.Label"), "success");
        });
    };

    const handleDisLikeClick = (event) => {
        event.stopPropagation();
        disLikeFeedback(id).then(() => {
            show(t("Src.Pages.Messages.FeedbackItem.Label"), "success");
        });
    };

    useLayoutEffect(() => {
        let newIntVal;

        if (feedback_status === 1) {
            setNewMessagesAlert(true);
            newIntVal = setInterval(() => {
                setNewMessagesAlert(false);
            }, 4000);
        } else {
            setNewMessagesAlert(false);
        }

        return () => clearInterval(newIntVal);
    }, [feedback_status]);

    if (id === undefined) {
        return (
            <tr style={{ minWidth: "100%" }}>
                <td colSpan="10">
                    <Skeleton count={1} style={{ fontSize: 60 }} />
                </td>
            </tr>
        );
    }

    const renderTooltip = (props) => (
        <Tooltip id="message-tooltip" {...props}>
            {description}
        </Tooltip>
    );

    return (
        <tr
            id="feedback-item-list"
            className={
                "message-card-tr " + (newMessagesAlert ? " new-feedbacks" : "")
            }
            onClick={() => onItemClick(id)}
        >
            <td>
                <div className="row_nu">{row}</div>
            </td>
            <td>
                <div className="info_st">
                    {showCoins
                        ? company || item?.company_name || "-"
                        : user?.first_name || user?.last_name
                        ? user.first_name + " " + user.last_name
                        : t("Src.Pages.Messages.FeedbackItem.Guest.User.Label")}
                </div>
            </td>
            <td>
                <div className="info_st">
                    {item?.item_type_name ? item?.item_type_name : "-"}
                </div>
            </td>
            <td>
                <div className="info_st item-name">
                    {item?.name ? item?.name : "-"}
                </div>
            </td>
            <td>
                <div className="info_st item-name img-con">
                    <div className="images-thumbnail">
                        <img alt="" src={file !== null ? file : defaultImg} />
                    </div>
                </div>
            </td>
            <td>
                <div className="date_time_st">
                    <CalendarIcon />
                    <span className="details_value">
                        {moment(datetime).format("jYYYY/jMM/jDD")}
                    </span>
                    <span className="date_type">
                        {moment(datetime).format("HH:mm")}
                    </span>
                </div>
            </td>
            <td>
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip}
                >
                    <div className="des_st">
                        <CommentIcon />
                        {description !== "" ? (
                            <span>{getTextDigest(description)}</span>
                        ) : (
                            <span className="empty-des">
                                {t(
                                    "Src.Pages.Messages.FeedbackItemList.NoMessage"
                                )}
                            </span>
                        )}
                    </div>
                </OverlayTrigger>
            </td>
            <td>
                <div className="info_st">
                    <MessageStatusBadge status={feedback_status} />
                </div>
            </td>
            <td>
                <div className="score_st">
                    <Target />
                    <div
                        dir="ltr"
                        style={{ transform: "scaleX(-1) translateY(-3px)" }}
                    >
                        <StarRatings
                            rating={computed_score}
                            starDimension="20px"
                            starSpacing="0px"
                            starRatedColor="rgb(254, 183, 48)"
                            starEmptyColor="#ccc"
                        />
                    </div>
                    <span className="avg-score">{round(computed_score)}</span>
                    {/* <span  >{round(computed_score)}</span> */}
                </div>
            </td>
            {showCoins && (
                <td>
                    <div className="info_st">{user_coin || 0}</div>
                </td>
            )}
            {/* <td><div className="last_status_st">
        <span>وضعیت</span>
        <AlertBox />
      </div></td> */}
            <td className="progress_main">
                <div className="likes_st">
                    <div>
                        <span>{likes_count}</span>
                        <IconBox
                            specialClass="likes_bg_st"
                            iconName="disLikeIcon"
                            clickFunction={handleLikeClick}
                        />
                    </div>
                    <div>
                        <span>{dislikes_count}</span>
                        <IconBox
                            specialClass="likes_bg_st"
                            iconName="likeIcon"
                            clickFunction={handleDisLikeClick}
                        />
                    </div>
                </div>
                {/* <div className="progress_st">
          <IconBox iconName="otherDotsIcon" />
        </div> */}
            </td>
        </tr>
    );
}
